import { render, staticRenderFns } from "./menulist.vue?vue&type=template&id=d3221a54&scoped=true"
import script from "./menulist.vue?vue&type=script&lang=ts"
export * from "./menulist.vue?vue&type=script&lang=ts"
import style0 from "./menulist.vue?vue&type=style&index=0&id=d3221a54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3221a54",
  null
  
)

export default component.exports